namespace TabAurous.Common {
    export enum SalaryComponentType {
        Earnings = 1,
        Deduction = 2
    }
    Serenity.Decorators.registerEnumType(SalaryComponentType, 'TabAurous.Common.SalaryComponentType', 'HR.SalaryComponentType');
}
